import React from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import {
    withStyles,
    Typography,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Table,
} from "@material-ui/core";

import { formatDate, formatStatus } from "../../lib/helperFuncs.jsx";
import {isObject} from "lodash";

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose } = props;
    return (
        <MuiDialogTitle disableTypography>
            <Typography variant="h5">{children}</Typography>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const ResHistoryView = (props) => {
    const outerHistory = [...props.history];

    const actions = outerHistory.map((action) => {
        const comment =
            action.comment !== "" ? action.comment : "Нет комментариев";
        let diffCells = [];
        if (Array.isArray(action?.diff)) {
            action.diff?.forEach((diffItem) => {
                const diffKey = Object.keys(diffItem)[0];
                const diffValue = diffItem[diffKey];
                const oldValue = Array.isArray(diffValue) ? diffValue[0] : null;
                const newValue = Array.isArray(diffValue) ? diffValue[1] : null;
                diffCells.push(
                    <TableRow key={diffKey}>
                        <TableCell>
                            <span style={{ fontWeight: "bold", color: "blue" }}>
                                {diffKey}:{" "}
                            </span>
                            {oldValue} &#8594; {newValue}
                        </TableCell>
                    </TableRow>,
                );
            });
        } else if (typeof action?.diff === "object") {
            for (const [key, value] of Object.entries(action.diff)) {
                if (['children_info', 'comment', 'prices_dates'].includes(key)) {
                    continue;
                }
                const oldValue = Array.isArray(value) ? value[0] : null;
                const newValue = Array.isArray(value) ? value[1] : null;
                diffCells.push(
                    <TableRow key={key}>
                        <TableCell>
                            <span style={{ fontWeight: "bold", color: "blue" }}>
                                {key}:{" "}
                            </span>
                            {oldValue} &#8594; {newValue}
                        </TableCell>
                    </TableRow>,
                );
            }
        } else if (typeof action?.refund === "object") {
            for (const [key, value] of Object.entries(action.refund)) {
                diffCells.push(
                    <TableRow key={key}>
                        <TableCell>
                            <span style={{ fontWeight: "bold", color: "blue" }}>
                                {key}:{" "}
                            </span>
                            { isObject(value) ? value.before + ' => ' + value.after : value }
                        </TableCell>
                    </TableRow>,
                );
            }
        }
        return (
            <TableRow key={action.added_on}>
                <TableCell>{formatDate(action.added_on)}</TableCell>

                {diffCells.length == 0 && (
                    <TableCell>{`${formatStatus(
                        action.old_status,
                        props.fields,
                    )} => ${formatStatus(action.status, props.fields)}`}</TableCell>
                )}
                {diffCells}
                {typeof action?.user_id === "string" ? (
                    <TableCell>Пользователь: {action.user_id}</TableCell>
                ) : (
                    <TableCell>{comment}</TableCell>
                )}
            </TableRow>
        );
    });

    const historyTable =
        outerHistory.length === 0 ? (
            <Typography style={{ minWidth: 310, padding: "1rem" }}>
                История изменений отсутствует
            </Typography>
        ) : (
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Дата</TableCell>
                        <TableCell>Изменение</TableCell>
                        <TableCell>Комментарий</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>{actions}</TableBody>
            </Table>
        );

    return (
        <Dialog
            maxWidth="lg"
            open={props.openResHistoryDialog}
            onClose={() => props.setOpenResHistoryDialog(false)}
            scroll={"body"}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <DialogTitle
                id="customized-dialog-title"
                onClose={() => props.setOpenResHistoryDialog(false)}
            >
                История изменений
            </DialogTitle>
            {historyTable}
        </Dialog>
    );
};

ResHistoryView.propTypes = {
    history: PropTypes.array,
    openResHistoryDialog: PropTypes.bool,
    setOpenResHistoryDialog: PropTypes.func,
    fields: PropTypes.object,
};

export default ResHistoryView;
